// ─────────────────────────────────────────────────────────────
//  FACILITY MANAGEMENT DUMMY DATA
// ─────────────────────────────────────────────────────────────

export const facilityDummyData = {
  summary: {
    healthScore: 87,
    criticalAlerts: 3,
    warningAlerts: 7,
    energyToday: 245,
    energyYesterday: 268,
    iaqIndex: 82,
    iaqLabel: "Good",
    waterUsageToday: 12500,
    waterUsageYesterday: 11800,
    openTickets: 5,
    closedTickets: 23,
    occupancy: 73,
    totalFloors: 6,
    totalAssets: 142,
    uptime: "99.2%",
    dgFuelToday: 48,
    dgFuelYesterday: 62,
    dgFuelCapacity: 500,
    dgFuelLevel: 71,
    dgRunHoursToday: 3.5,
    dgStatus: "Standby",
  },

  zones: [
    { id: 1, name: "Admin Block – F1",     temp: 23.4, humidity: 52, co2: 420,  pm25: 12, pm10: 22, voc: 0.18, status: "Good" },
    { id: 2, name: "Server Room – F2",     temp: 19.1, humidity: 38, co2: 510,  pm25: 8,  pm10: 14, voc: 0.12, status: "Good" },
    { id: 3, name: "Conference Hall – F3", temp: 26.8, humidity: 65, co2: 980,  pm25: 35, pm10: 58, voc: 0.42, status: "Warning" },
    { id: 4, name: "Reception – G/F",      temp: 28.2, humidity: 71, co2: 760,  pm25: 28, pm10: 44, voc: 0.31, status: "Warning" },
    { id: 5, name: "Cafeteria – F1",       temp: 31.5, humidity: 78, co2: 1150, pm25: 55, pm10: 89, voc: 0.68, status: "Critical" },
    { id: 6, name: "Parking – B1",         temp: 34.2, humidity: 55, co2: 890,  pm25: 48, pm10: 72, voc: 0.55, status: "Warning" },
  ],

  tanks: [
    { id: 1, name: "Overhead Tank A",    level: 78, capacity: 25000, unit: "L", status: "Normal",   pumpRunning: true,  flowRate: 12.5, leakDetected: false },
    { id: 2, name: "Overhead Tank B",    level: 42, capacity: 20000, unit: "L", status: "Low",      pumpRunning: true,  flowRate: 8.2,  leakDetected: false },
    { id: 3, name: "Underground Sump",   level: 88, capacity: 50000, unit: "L", status: "Normal",   pumpRunning: false, flowRate: 0,    leakDetected: false },
    { id: 4, name: "Fire Hydrant Tank",  level: 95, capacity: 15000, unit: "L", status: "Normal",   pumpRunning: false, flowRate: 0,    leakDetected: false },
    { id: 5, name: "STP Feed Tank",      level: 21, capacity: 10000, unit: "L", status: "Critical", pumpRunning: false, flowRate: 0,    leakDetected: true  },
  ],

  pumps: [
    { id: 1, name: "Main Transfer Pump",    status: "Running", power: "5 HP",   current: 12.4, runtime: "4h 22m",  health: 91 },
    { id: 2, name: "Booster Pump – F3",     status: "Running", power: "2 HP",   current: 6.1,  runtime: "1h 45m",  health: 85 },
    { id: 3, name: "Sump Pump 1",           status: "Fault",   power: "3 HP",   current: 0,    runtime: "—",       health: 38 },
    { id: 4, name: "Fire Suppression Pump", status: "Standby", power: "7.5 HP", current: 0,    runtime: "Standby", health: 98 },
    { id: 5, name: "STP Feed Pump",         status: "Off",     power: "1.5 HP", current: 0,    runtime: "—",       health: 72 },
  ],

  dg: {
    model: "Kirloskar KG2-250WS",
    capacity: "250 KVA",
    status: "Standby",
    fuelLevel: 71,
    fuelCapacity: 500,
    voltage: 415,
    frequency: 50.1,
    loadPercent: 0,
    coolingTemp: 82,
    oilPressure: 42,
    batteryVoltage: 24.1,
    totalRunHoursLifetime: 4820,
    lastServiceDate: "18 Feb 2026",
    nextServiceDate: "18 May 2026",
    weeklyHistory: [
      { day: "Mon", fuelUsed: 62, runHours: 4.5, startCount: 2, avgLoad: 68 },
      { day: "Tue", fuelUsed: 48, runHours: 3.5, startCount: 1, avgLoad: 71 },
      { day: "Wed", fuelUsed: 0,  runHours: 0,   startCount: 0, avgLoad: 0  },
      { day: "Thu", fuelUsed: 85, runHours: 6.2, startCount: 3, avgLoad: 74 },
      { day: "Fri", fuelUsed: 71, runHours: 5.1, startCount: 2, avgLoad: 72 },
      { day: "Sat", fuelUsed: 38, runHours: 2.8, startCount: 1, avgLoad: 65 },
      { day: "Sun", fuelUsed: 48, runHours: 3.5, startCount: 1, avgLoad: 69 },
    ],
  },

  electrical: {
    voltage: 233,
    current: 48.2,
    powerFactor: 0.91,
    frequency: 50.0,
    phaseImbalance: 1.8,
    dgStatus: "Standby",
    upsStatus: "Normal",
    totalLoad: 87.4,
    maxLoad: 150,
    floors: [
      { floor: "G/F",     consumption: 32.5, maxNorm: 40, tenant: "Lobby & Security" },
      { floor: "Floor 1", consumption: 41.2, maxNorm: 40, tenant: "Admin & HR" },
      { floor: "Floor 2", consumption: 28.8, maxNorm: 40, tenant: "IT & Server Room" },
      { floor: "Floor 3", consumption: 51.0, maxNorm: 40, tenant: "Operations" },
      { floor: "Floor 4", consumption: 35.6, maxNorm: 40, tenant: "Finance" },
      { floor: "Floor 5", consumption: 38.1, maxNorm: 40, tenant: "Executive Suite" },
    ],
  },

  equipment: [
    {
      id: 1, name: "AHU – Block A",       type: "HVAC",
      healthScore: 48, failureRisk: 72, daysToFailure: 10,
      vibration: "High", noise: "Abnormal",
      lastService: "45 days ago", nextService: "Overdue",
      aiAlert: "Abnormal vibration detected. Bearing replacement recommended within 10 days.",
      parts: ["Bearing", "Belt"],
    },
    {
      id: 2, name: "Chiller Unit 1",      type: "HVAC",
      healthScore: 74, failureRisk: 28, daysToFailure: 45,
      vibration: "Normal", noise: "Normal",
      lastService: "12 days ago", nextService: "In 18 days",
      aiAlert: "Refrigerant pressure slightly low. Monitor weekly.",
      parts: ["Filter"],
    },
    {
      id: 3, name: "Elevator Motor – T1", type: "Elevator",
      healthScore: 85, failureRisk: 14, daysToFailure: 90,
      vibration: "Normal", noise: "Normal",
      lastService: "5 days ago", nextService: "In 55 days",
      aiAlert: null, parts: [],
    },
    {
      id: 4, name: "Generator DG-1",      type: "Electrical",
      healthScore: 92, failureRisk: 8, daysToFailure: 120,
      vibration: "Normal", noise: "Normal",
      lastService: "8 days ago", nextService: "In 22 days",
      aiAlert: null, parts: [],
    },
    {
      id: 5, name: "Sump Pump 1",         type: "Plumbing",
      healthScore: 38, failureRisk: 88, daysToFailure: 3,
      vibration: "Critical", noise: "Abnormal",
      lastService: "90 days ago", nextService: "Overdue – URGENT",
      aiAlert: "Motor overheating detected. Immediate inspection required. Estimated failure in 2–4 days.",
      parts: ["Motor Winding", "Impeller", "Seal"],
    },
    {
      id: 6, name: "Fire Pump",           type: "Fire Safety",
      healthScore: 97, failureRisk: 3, daysToFailure: 180,
      vibration: "Normal", noise: "Normal",
      lastService: "2 days ago", nextService: "In 88 days",
      aiAlert: null, parts: [],
    },
  ],

  assets: [
    { id: "AST-001", name: "AHU Unit – Block A",       type: "HVAC",       healthIndex: 48, warranty: "Expired",  amc: "Valid till Dec 2025", lastService: "45 days ago" },
    { id: "AST-002", name: "Chiller Unit 1",            type: "HVAC",       healthIndex: 74, warranty: "Oct 2026", amc: "Valid till Mar 2026", lastService: "12 days ago" },
    { id: "AST-003", name: "Chiller Unit 2",            type: "HVAC",       healthIndex: 81, warranty: "Oct 2026", amc: "Valid till Mar 2026", lastService: "18 days ago" },
    { id: "AST-004", name: "Elevator T1",               type: "Elevator",   healthIndex: 85, warranty: "Jun 2027", amc: "Valid till Jun 2026", lastService: "5 days ago" },
    { id: "AST-005", name: "DG Set 1 – 250 KVA",       type: "Electrical", healthIndex: 92, warranty: "Feb 2027", amc: "Valid till Feb 2026", lastService: "8 days ago" },
    { id: "AST-006", name: "Sump Pump 1",               type: "Plumbing",   healthIndex: 38, warranty: "Expired",  amc: "Expired",             lastService: "90 days ago" },
    { id: "AST-007", name: "Fire Suppression System",   type: "Fire Safety",healthIndex: 97, warranty: "Jan 2028", amc: "Valid till Jan 2027", lastService: "2 days ago" },
    { id: "AST-008", name: "UPS System – IT Floor",     type: "Electrical", healthIndex: 88, warranty: "Sep 2025", amc: "Valid till Sep 2025", lastService: "15 days ago" },
    { id: "AST-009", name: "CCTV Network – Block A",    type: "Security",   healthIndex: 79, warranty: "Mar 2026", amc: "Valid till Mar 2026", lastService: "30 days ago" },
    { id: "AST-010", name: "Access Control System",     type: "Security",   healthIndex: 94, warranty: "Jul 2027", amc: "Valid till Jul 2026", lastService: "3 days ago" },
  ],

  alerts: [
    { id: "ALT-001", severity: "Critical", type: "Equipment Failure", location: "Basement – Sump Pump 1", message: "Sump Pump 1 motor overheating. Failure imminent.",   status: "Open",     assignee: "Maintenance Team A" },
    { id: "ALT-002", severity: "Critical", type: "Leakage Detected",  location: "STP Feed Tank",          message: "Water leakage near STP inlet valve.",                status: "Open",     assignee: "Plumbing Team" },
    { id: "ALT-003", severity: "Critical", type: "Air Quality",       location: "Cafeteria – Floor 1",    message: "PM2.5 = 55 ug/m3. Unsafe air quality level.",        status: "Open",     assignee: "Facility Manager" },
    { id: "ALT-004", severity: "Warning",  type: "Low Tank Level",    location: "STP Feed Tank",          message: "STP Feed Tank at 21%. Refill required.",             status: "Open",     assignee: "Operations" },
    { id: "ALT-005", severity: "Warning",  type: "Over Temperature",  location: "Cafeteria – Floor 1",    message: "Temperature 31.5C exceeds comfort threshold.",       status: "Open",     assignee: "HVAC Team" },
    { id: "ALT-006", severity: "Warning",  type: "High Energy",       location: "Floor 3 – Operations",   message: "Floor 3 consuming 27% above daily average.",         status: "Open",     assignee: "Energy Manager" },
    { id: "ALT-007", severity: "Warning",  type: "Predictive",        location: "AHU – Block A",          message: "Bearing wear detected. Service within 10 days.",     status: "Open",     assignee: "HVAC Team" },
    { id: "ALT-008", severity: "Info",     type: "Maintenance Due",   location: "Chiller Unit 1",         message: "Scheduled service due in 18 days.",                  status: "Resolved", assignee: "HVAC Team" },
    { id: "ALT-009", severity: "Info",     type: "Access Log",        location: "Server Room – Floor 2",  message: "After-hours access by EMP-0042.",                    status: "Resolved", assignee: "Security" },
    { id: "ALT-010", severity: "Info",     type: "Firmware Update",   location: "Gateway GW-001",         message: "Firmware v2.4.1 available. Schedule update.",        status: "Resolved", assignee: "IT Team" },
  ],

  energy: {
    carbonFootprintKg: 112.4,
    peakLoadTime: "2:00 PM – 4:00 PM",
    aiTips: [
      "Reduce HVAC load between 2–4 PM. Potential saving: 18 kWh/day.",
      "Floor 3 consuming 27% above average. Review AC scheduler.",
      "Shift heavy loads to off-peak (11 PM – 5 AM) for 15% cost reduction.",
    ],
    hourly: [
      { h: "12 AM", v: 18 }, { h: "2 AM",  v: 14 }, { h: "4 AM",  v: 12 },
      { h: "6 AM",  v: 22 }, { h: "8 AM",  v: 48 }, { h: "10 AM", v: 62 },
      { h: "12 PM", v: 71 }, { h: "2 PM",  v: 85 }, { h: "4 PM",  v: 78 },
      { h: "6 PM",  v: 55 }, { h: "8 PM",  v: 38 }, { h: "10 PM", v: 24 },
    ],
    weekly: [
      { d: "Mon", v: 268 }, { d: "Tue", v: 245 }, { d: "Wed", v: 271 },
      { d: "Thu", v: 258 }, { d: "Fri", v: 283 }, { d: "Sat", v: 142 }, { d: "Sun", v: 98 },
    ],
  },

  warehouseZones: [
    { id: "A", name: "Receiving",     x: 2,  y: 2,  w: 20, h: 38, fill: "#dbeafe", stroke: "#3b82f6" },
    { id: "B", name: "Storage North", x: 24, y: 2,  w: 36, h: 38, fill: "#dcfce7", stroke: "#10b981" },
    { id: "C", name: "Cold Storage",  x: 62, y: 2,  w: 36, h: 38, fill: "#e0f2fe", stroke: "#0ea5e9" },
    { id: "D", name: "Processing",    x: 2,  y: 42, w: 58, h: 30, fill: "#fef9c3", stroke: "#eab308" },
    { id: "E", name: "Dispatch",      x: 62, y: 42, w: 36, h: 30, fill: "#fce7f3", stroke: "#ec4899" },
    { id: "F", name: "Office",        x: 2,  y: 74, w: 42, h: 24, fill: "#f3e8ff", stroke: "#8b5cf6" },
    { id: "G", name: "Maintenance",   x: 46, y: 74, w: 52, h: 24, fill: "#ffedd5", stroke: "#f97316" },
  ],

  movableAssets: [
    { id: "FL-001", name: "Forklift FL-01",      type: "Forklift",       zone: "B", x: 36, y: 18, status: "Active",   battery: 78, lastSeen: "2 min ago",  assignedTo: "Ravi Kumar"   },
    { id: "FL-002", name: "Forklift FL-02",      type: "Forklift",       zone: "D", x: 22, y: 53, status: "Active",   battery: 91, lastSeen: "1 min ago",  assignedTo: "Arjun Singh"  },
    { id: "FL-003", name: "Forklift FL-03",      type: "Forklift",       zone: "A", x: 8,  y: 22, status: "Idle",    battery: 55, lastSeen: "15 min ago", assignedTo: "Unassigned"   },
    { id: "RB-001", name: "AGV Robot RB-01",     type: "AGV Robot",      zone: "D", x: 42, y: 48, status: "Active",   battery: 67, lastSeen: "0 min ago",  assignedTo: "Auto"         },
    { id: "RB-002", name: "AGV Robot RB-02",     type: "AGV Robot",      zone: "B", x: 52, y: 12, status: "Charging", battery: 22, lastSeen: "18 min ago", assignedTo: "Charging Bay" },
    { id: "CT-001", name: "Cargo Cart CC-01",    type: "Cargo Cart",     zone: "E", x: 75, y: 55, status: "Active",   battery: 83, lastSeen: "5 min ago",  assignedTo: "Suresh Nair"  },
    { id: "CT-002", name: "Cargo Cart CC-02",    type: "Cargo Cart",     zone: "A", x: 12, y: 34, status: "Idle",    battery: 45, lastSeen: "8 min ago",  assignedTo: "Unassigned"   },
    { id: "EMP-001", name: "Badge – Rahul Kumar",  type: "Employee Badge", zone: "F", x: 18, y: 82, status: "Active", battery: 88, lastSeen: "1 min ago",  assignedTo: "Rahul Kumar"  },
    { id: "EMP-002", name: "Badge – Priya Mehta",  type: "Employee Badge", zone: "D", x: 30, y: 57, status: "Active", battery: 72, lastSeen: "2 min ago",  assignedTo: "Priya Mehta"  },
    { id: "EMP-003", name: "Badge – Anjali Rao",   type: "Employee Badge", zone: "B", x: 42, y: 28, status: "Active", battery: 91, lastSeen: "0 min ago",  assignedTo: "Anjali Rao"   },
    { id: "EMP-004", name: "Badge – Suresh Nair",  type: "Employee Badge", zone: "C", x: 72, y: 20, status: "Active", battery: 65, lastSeen: "3 min ago",  assignedTo: "Suresh Nair"  },
    { id: "LT-001", name: "Laptop LT-001",       type: "Laptop",         zone: "F", x: 28, y: 88, status: "Active",   battery: 82, lastSeen: "5 min ago",  assignedTo: "IT Dept"      },
    { id: "LT-002", name: "Laptop LT-002",       type: "Laptop",         zone: "G", x: 65, y: 83, status: "Idle",    battery: null, lastSeen: "2 hrs ago", assignedTo: "Maintenance"  },
    { id: "TB-001", name: "Tablet TB-001",        type: "Tablet",         zone: "D", x: 55, y: 52, status: "Active",   battery: 58, lastSeen: "4 min ago",  assignedTo: "Operations"   },
  ],

  occupancy: {
    totalCapacity: 850,
    currentOccupancy: 621,
    occupancyPct: 73,
    peakToday: 698,
    peakTime: "11:00 AM",
    entryToday: 748,
    exitToday: 127,
    floors: [
      { id: 1, name: "G/F – Lobby & Security", capacity: 80,  current: 68,  status: "Normal" },
      { id: 2, name: "Floor 1 – Admin & HR",   capacity: 150, current: 124, status: "Normal" },
      { id: 3, name: "Floor 2 – IT & Servers", capacity: 120, current: 95,  status: "Normal" },
      { id: 4, name: "Floor 3 – Operations",   capacity: 200, current: 185, status: "High"   },
      { id: 5, name: "Floor 4 – Finance",      capacity: 150, current: 88,  status: "Normal" },
      { id: 6, name: "Floor 5 – Executive",    capacity: 100, current: 41,  status: "Low"    },
      { id: 7, name: "Cafeteria",              capacity: 120, current: 98,  status: "High"   },
      { id: 8, name: "Conference Halls",       capacity: 200, current: 22,  status: "Low"    },
    ],
    hourlyTrend: [
      { h: "8 AM",  v: 42  }, { h: "9 AM",  v: 218 }, { h: "10 AM", v: 485 },
      { h: "11 AM", v: 698 }, { h: "12 PM", v: 571 }, { h: "1 PM",  v: 498 },
      { h: "2 PM",  v: 621 }, { h: "3 PM",  v: 598 }, { h: "4 PM",  v: 532 },
      { h: "5 PM",  v: 312 }, { h: "6 PM",  v: 142 }, { h: "7 PM",  v: 58  },
    ],
    weeklyAvg: [
      { d: "Mon", v: 578 }, { d: "Tue", v: 612 }, { d: "Wed", v: 598 },
      { d: "Thu", v: 621 }, { d: "Fri", v: 587 }, { d: "Sat", v: 142 }, { d: "Sun", v: 38 },
    ],
  },

  restrooms: [
    {
      id: 1, name: "Restroom G/F – Male",    floor: "G/F",     type: "Male",
      occupied: false, cleaningStatus: "Clean",
      lastCleaned: "45 min ago", nextCleaning: "In 1h 15m",
      odorLevel: 12, humidity: 66, temperature: 24.2,
      sanitizerLevel: 78, paperLevel: 85, soapLevel: 90,
      dailyUsage: 142, flushCount: 186,
      alerts: [],
    },
    {
      id: 2, name: "Restroom G/F – Female",  floor: "G/F",     type: "Female",
      occupied: true, cleaningStatus: "Attention",
      lastCleaned: "1h 20min ago", nextCleaning: "In 40m",
      odorLevel: 24, humidity: 74, temperature: 25.1,
      sanitizerLevel: 45, paperLevel: 22, soapLevel: 81,
      dailyUsage: 168, flushCount: 214,
      alerts: ["Paper level low – refill soon"],
    },
    {
      id: 3, name: "Restroom F1 – Male",     floor: "Floor 1", type: "Male",
      occupied: true, cleaningStatus: "Clean",
      lastCleaned: "30 min ago", nextCleaning: "In 1h 30m",
      odorLevel: 8,  humidity: 62, temperature: 23.8,
      sanitizerLevel: 92, paperLevel: 77, soapLevel: 85,
      dailyUsage: 98, flushCount: 128,
      alerts: [],
    },
    {
      id: 4, name: "Restroom F1 – Female",   floor: "Floor 1", type: "Female",
      occupied: false, cleaningStatus: "Clean",
      lastCleaned: "55 min ago", nextCleaning: "In 1h 5m",
      odorLevel: 6,  humidity: 60, temperature: 23.5,
      sanitizerLevel: 88, paperLevel: 90, soapLevel: 94,
      dailyUsage: 112, flushCount: 145,
      alerts: [],
    },
    {
      id: 5, name: "Restroom F3 – Male",     floor: "Floor 3", type: "Male",
      occupied: false, cleaningStatus: "Needs Service",
      lastCleaned: "3h 10min ago", nextCleaning: "Overdue",
      odorLevel: 68, humidity: 82, temperature: 27.4,
      sanitizerLevel: 12, paperLevel: 5,  soapLevel: 18,
      dailyUsage: 210, flushCount: 278,
      alerts: ["Overdue cleaning", "Sanitizer critically low", "Paper critically low", "High odor detected"],
    },
    {
      id: 6, name: "Restroom F3 – Female",   floor: "Floor 3", type: "Female",
      occupied: true, cleaningStatus: "Attention",
      lastCleaned: "1h 45min ago", nextCleaning: "In 15m",
      odorLevel: 38, humidity: 78, temperature: 26.8,
      sanitizerLevel: 34, paperLevel: 48, soapLevel: 52,
      dailyUsage: 224, flushCount: 296,
      alerts: ["Sanitizer level low", "Cleaning due soon"],
    },
    {
      id: 7, name: "Restroom F5 – Male",     floor: "Floor 5", type: "Male",
      occupied: false, cleaningStatus: "Clean",
      lastCleaned: "20 min ago", nextCleaning: "In 1h 40m",
      odorLevel: 4,  humidity: 55, temperature: 22.9,
      sanitizerLevel: 95, paperLevel: 88, soapLevel: 96,
      dailyUsage: 52, flushCount: 68,
      alerts: [],
    },
    {
      id: 8, name: "Restroom F5 – Female",   floor: "Floor 5", type: "Female",
      occupied: false, cleaningStatus: "Clean",
      lastCleaned: "1h 5min ago", nextCleaning: "In 55m",
      odorLevel: 5,  humidity: 57, temperature: 23.1,
      sanitizerLevel: 91, paperLevel: 82, soapLevel: 89,
      dailyUsage: 44, flushCount: 58,
      alerts: [],
    },
    {
      id: 9, name: "Restroom Cafeteria – Unisex", floor: "Cafeteria", type: "Unisex",
      occupied: true, cleaningStatus: "Attention",
      lastCleaned: "2h 5min ago", nextCleaning: "In 5m",
      odorLevel: 45, humidity: 80, temperature: 28.2,
      sanitizerLevel: 28, paperLevel: 35, soapLevel: 62,
      dailyUsage: 320, flushCount: 418,
      alerts: ["Cleaning due", "Sanitizer level low"],
    },
  ],

  security: {
    fireZones: [
      { id: 1, zone: "Ground Floor",        status: "Normal",  lastTest: "3 days ago" },
      { id: 2, zone: "Floor 1",             status: "Normal",  lastTest: "3 days ago" },
      { id: 3, zone: "Floor 2 – Server",    status: "Normal",  lastTest: "1 day ago" },
      { id: 4, zone: "Floor 3",             status: "Normal",  lastTest: "3 days ago" },
      { id: 5, zone: "Basement",            status: "Warning", lastTest: "12 days ago" },
    ],
    accessLogs: [
      { id: 1, empId: "EMP-0042", name: "Rahul Sharma", location: "Server Room",   type: "After Hours",  granted: true },
      { id: 2, empId: "EMP-0118", name: "Priya Mehta",  location: "Main Entry",    type: "Normal",       granted: true },
      { id: 3, empId: "VIS-0023", name: "Visitor",       location: "Reception",     type: "Visitor",      granted: true },
      { id: 4, empId: "UNK-XXXX", name: "Unknown Card", location: "Roof Access",   type: "Unauthorized", granted: false },
      { id: 5, empId: "EMP-0205", name: "Anjali Rao",   location: "Finance Floor", type: "Normal",       granted: true },
    ],
    visitorCount: 34,
    panicAlarms: 0,
    cctvActive: 28,
    cctvTotal: 32,
  },
};
